import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface UploadResult {
  filename: string;
  api?: string;
  flag?: boolean;
  distance?: number;
  tolerance?: number;
  calculated_bh_x?: number;
  calculated_bh_y?: number;
  reference_bh_x?: number;
  reference_bh_y?: number;
  error?: string;
}

export interface UploadResponse {
  results: UploadResult[];
}

export interface ResolveEpsgResult {
  filename: string;
  api?: string;
  epsg_code?: number;
  region?: string;
  region_description?: string;
  error?: string;
}

export interface ResolveEpsgResponse {
  results: ResolveEpsgResult[];
}

export interface ResolveEpsgCodeResponse {
  epsg_code: number;
  region?: string;
  region_description?: string;
  error?: string;
}

@Injectable({ providedIn: 'root' })
export class UploadApiService {
  private readonly apiBaseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  upload(formData: FormData): Observable<UploadResponse> {
    return this.http.post<UploadResponse>(`${this.apiBaseUrl}/upload`, formData);
  }

  resolveEpsg(filenames: string[]): Observable<ResolveEpsgResponse> {
    return this.http.post<ResolveEpsgResponse>(`${this.apiBaseUrl}/resolve-epsg`, { filenames });
  }

  resolveEpsgCode(epsgCode: number): Observable<ResolveEpsgCodeResponse> {
    return this.http.post<ResolveEpsgCodeResponse>(`${this.apiBaseUrl}/resolve-epsg-code`, { epsg_code: epsgCode });
  }
}